import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CloseButtonComponent } from '../close-button/close-button.component';

export interface ConfirmationDialogData {
  title: string;
  text: string;
  confirmText?: string;
  cancelText?: string;
}

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmationDialogComponent>);
  readonly data = inject<ConfirmationDialogData>(MAT_DIALOG_DATA);
  get confirmText(): string { return this.data?.confirmText || 'Confirm' };
  get cancelText(): string { return this.data?.cancelText || 'Cancel' };
  get title(): string { return this.data?.title || 'Confirmation' };
  get text(): string { return this.data?.text || '' };

  onClose(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
